module.exports = [{
      plugin: require('/builds/atomix/candidate-projects/base/frontend/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
